import script from "./test-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./test-page.vue?vue&type=script&setup=true&lang=ts"

import "./test-page.vue?vue&type=style&index=0&id=6a113c08&lang=less"

const __exports__ = script;

export default __exports__